import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { RadioField } from '@frontend/design-system';
import { Corners } from '../types';
import { Setting } from './setting';
import { getRadioOptionStyles, radioFieldStyles } from './styles';

type Props = ComponentProps<typeof RadioField> & {
  value: Corners;
};

export const CornersSetting = (props: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting.Item label={t('Corners')}>
      <RadioField {...props} css={radioFieldStyles}>
        <RadioField.Radio value='square' className='hide-radio' css={getRadioOptionStyles(props.value === 'square')}>
          <div
            css={{
              border: `3px solid ${theme.colors.neutral90}`,
              height: theme.spacing(2.5),
              width: theme.spacing(2.5),
            }}
          ></div>
        </RadioField.Radio>
        <RadioField.Radio value='rounded' className='hide-radio' css={getRadioOptionStyles(props.value === 'rounded')}>
          <div
            css={{
              border: `3px solid ${theme.colors.neutral90}`,
              borderRadius: theme.borderRadius.small,
              height: theme.spacing(2.5),
              width: theme.spacing(2.5),
            }}
          ></div>
        </RadioField.Radio>
        <RadioField.Radio value='pill' className='hide-radio' css={getRadioOptionStyles(props.value === 'pill')}>
          <div
            css={{
              border: `3px solid ${theme.colors.neutral90}`,
              borderRadius: '50%',
              height: theme.spacing(2.5),
              width: theme.spacing(2.5),
            }}
          ></div>
        </RadioField.Radio>
      </RadioField>
    </Setting.Item>
  );
};
